export default __webpack_public_path__ + "static/media/influens.a2da6e73.png";